import Footer from "../../footer"
import NavBar from "../../nav"

const HazardousMaterials = () => {
  return <div className='hazardous-materials'>
    <NavBar />
    <div>
    <section className="clean-block pfa-content clearfix">
			<div className="divider sections">
				<h1>Hazardous Materials Manuals</h1>
				<div className="headline-divider sections"></div>
				<h2>Carriage and Non-Carriage</h2>
				<h3>Keeping Our Clients Compliant.</h3>
			</div>
		</section>
    <section className="clean-block clearfix">	
			<div className="container content-container about-container">	
				<div className="prose">Fly Compliant, LLC in concert with the FAA Air Carrier Systems Design Branch, AXH-350 Hazardous Materials Safety Program have developed a compliant Hazardous Material Manual. 49 CFR 175.10, 175.33 and 175.78 have had recent changes that occurred on May 15th, 2020 and all hazardous materials manuals need to be updated and approved.</div>
				<div className="prose not-first">Lithium batteries are the driver of many of these changes as well as passenger other regulated material.</div>
				<div className="prose not-first">For more information regarding our Hazardous Materials Manuals, <a href="/contact-us">contact our team</a>.</div>
			</div>
		</section>
    </div>
    <Footer />
  </div>
}

export default HazardousMaterials